import { render } from "./Calendar.vue?vue&type=template&id=5823996c&scoped=true"
import script from "./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue?vue&type=script&lang=js"

import "./Calendar.vue?vue&type=style&index=0&id=5823996c&scoped=true&lang=css"
import "./Calendar.vue?vue&type=style&index=1&id=5823996c&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5823996c"]])

export default __exports__